"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseGeoPoint = exports.isParsableAsGeoPoint = void 0;
function isGeoPoint(v) {
    return v instanceof Object && !isNaN(v.latitude) && !isNaN(v.longitude);
}
var geoPointRegex = /\s*\(?(-?\d+.\d+)?,\s*(-?\d+.\d+)\)?\s*/;
function tryToParseGeoPoint(v) {
    if (!v) {
        return false;
    }
    if (typeof v === "string") {
        var match = v.match(geoPointRegex);
        if (!match) {
            return false;
        }
        return {
            latitude: Number(match[1]),
            longitude: Number(match[2]),
        };
    }
    if (Array.isArray(v)) {
        if (v.length !== 2 || isNaN(v[0]) || isNaN(v[1])) {
            return false;
        }
        return {
            latitude: Number(v[0]),
            longitude: Number(v[1]),
        };
    }
    if (v instanceof Object) {
        var latitude = v.latitude || v.lat;
        var longitude = v.longitude || v.lon;
        if (isNaN(latitude) || isNaN(longitude)) {
            return false;
        }
        return {
            latitude: Number(latitude),
            longitude: Number(longitude),
        };
    }
    return false;
}
function isParsableAsGeoPoint(v) {
    return !!tryToParseGeoPoint(v);
}
exports.isParsableAsGeoPoint = isParsableAsGeoPoint;
function parseGeoPoint(v) {
    var geoPoint = tryToParseGeoPoint(v);
    if (isGeoPoint(geoPoint)) {
        return geoPoint;
    }
    throw new Error("invalid use of parseGeoPoint - use isParsableAsGeoPoint first");
}
exports.parseGeoPoint = parseGeoPoint;
//# sourceMappingURL=geopoint.js.map